(function () {
  'use strict';

  function track(action, details) {
    if (window.KootaTracking && typeof window.KootaTracking.track === 'function') {
      window.KootaTracking.track('koota_contact_interaction', Object.assign({
        contact_action: action
      }, details || {}));
    }
  }

  function initContact(root) {
    if (!root || root.dataset.kootaContactReady === 'true') return;
    root.dataset.kootaContactReady = 'true';

    var topicSelect = root.querySelector('[data-koota-contact-topic-select]');
    var message = root.querySelector('#ContactForm-body');
    var count = root.querySelector('[data-koota-contact-count]');
    var orderInput = root.querySelector('#ContactForm-order');
    var form = root.querySelector('#ContactForm');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function scrollToAnchor(link) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#' || href.length < 2) return false;

      var target = document.getElementById(href.slice(1));
      if (!target) return false;

      var header = document.querySelector('.section-header');
      var headerHeight = header ? header.getBoundingClientRect().height : 0;
      var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 24;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', href);
      }

      return true;
    }

    function updateCount() {
      if (message && count) count.textContent = String(message.value.length);
    }

    function highlightOrderField() {
      if (!topicSelect || !orderInput) return;
      var isOrder = topicSelect.value === 'Commande' || topicSelect.value === 'Livraison';
      orderInput.closest('.koota-contact__field').classList.toggle('koota-contact__field--suggested', isOrder);
      orderInput.placeholder = isOrder ? 'Ex. #1042 — cela accélère notre recherche' : 'Ex. #1042';
    }

    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (event.defaultPrevented || !scrollToAnchor(link)) return;
        event.preventDefault();
      });
    });

    root.querySelectorAll('[data-koota-contact-topic]').forEach(function (link) {
      link.addEventListener('click', function () {
        if (!topicSelect) return;
        var topic = link.getAttribute('data-koota-contact-topic');
        var matchingOption = Array.prototype.some.call(topicSelect.options, function (option) {
          return option.value === topic;
        });

        if (matchingOption) {
          topicSelect.value = topic;
          topicSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        track('intent_selected', { contact_topic: topic });
        window.setTimeout(function () {
          topicSelect.focus({ preventScroll: true });
        }, 550);
      });
    });

    root.querySelectorAll('.koota-contact__intent[href]:not([data-koota-contact-topic])').forEach(function (link) {
      link.addEventListener('click', function () {
        track('self_service_selected', {
          destination: link.getAttribute('href'),
          intent_label: (link.querySelector('strong') || {}).textContent || ''
        });
      });
    });

    if (topicSelect) {
      topicSelect.addEventListener('change', function () {
        highlightOrderField();
        if (topicSelect.value) track('topic_selected', { contact_topic: topicSelect.value });
      });

      var queryTopic = new URLSearchParams(window.location.search).get('sujet');
      if (queryTopic) {
        Array.prototype.some.call(topicSelect.options, function (option) {
          if (option.value.toLocaleLowerCase('fr') === queryTopic.toLocaleLowerCase('fr')) {
            topicSelect.value = option.value;
            return true;
          }
          return false;
        });
      }
      highlightOrderField();
    }

    if (message) {
      updateCount();
      message.addEventListener('input', updateCount);
    }

    root.querySelectorAll('.koota-contact__faq-item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        root.querySelectorAll('.koota-contact__faq-item[open]').forEach(function (openItem) {
          if (openItem !== item) openItem.removeAttribute('open');
        });
        var summary = item.querySelector('summary');
        track('faq_opened', { faq_question: summary ? summary.textContent.trim() : '' });
      });
    });

    if (form && message) {
      var formStarted = false;
      form.addEventListener('focusin', function () {
        if (formStarted) return;
        formStarted = true;
        track('form_started');
      });

      form.addEventListener('submit', function () {
        track('form_submitted', {
          contact_topic: topicSelect ? topicSelect.value : '',
          has_order_number: Boolean(orderInput && orderInput.value.trim())
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-koota-contact]').forEach(initContact);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initContact(event.target.querySelector('[data-koota-contact]'));
  });
})();
